import script from "./UiInput.vue?vue&type=script&setup=true&lang=js"
export * from "./UiInput.vue?vue&type=script&setup=true&lang=js"

import "./UiInput.vue?vue&type=style&index=0&id=78c45154&lang=css"

const __exports__ = script;

export default __exports__